var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-image",on:{"click":_vm.onClick,"touch":_vm.onClick}},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":"推し画像"}})])}
var staticRenderFns = []

export { render, staticRenderFns }